export default __webpack_public_path__ + "static/media/step2.51315914.png";